<template>
    <v-text-field
        v-model="formData.value"
        outlined
        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
        :type="showPassword ? 'text' : 'password'"
        :class="inputCssClass"
        :label="title"
        :disabled="!!readonly"
        placeholder=""
        :error-messages="formData.value_error || errorMessages"
        :test-id="testId"
        @input="valueChanged"
        @click:append="showPassword = !showPassword"
    ></v-text-field>
</template>

<script>
import { ref } from "@vue/composition-api";

export default {
    name: "CustomTextField",
    props: {
        field: {
            type: Object,
            required: true
        },
        value: {
            type: [String, Number],
            default: null
        },
        errorMessages: {
            type: String,
            default: null
        },
        inputCssClass: {
            type: String,
            default: ""
        },
        readonly: {
            type: Number,
            default: 0
        },
        testId:{
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: null
        }
    },
    setup(props, ctx) {
        const formData = ref({
            value: props.value,
            value_error: null
        });

        const showPassword = ref(false)

        const valueChanged = () => {
            ctx.emit("change", formData.value.value);
        }

        return {
            formData,
            showPassword,
            valueChanged
        };
    }
};
</script>
